
let envSource;

if (process.env.NODE_ENV === 'development') {
  envSource = process.env;
} else {
  envSource = window.__env__;
}

export const {
  REACT_APP_API_ORIGIN,
  REACT_APP_RECAPTCHA_SITE_KEY
} = envSource;

export const SOURCE = "CORPORATE_WEBSITE";
export const STATUS = "NEW";
export const KZ = 'kk';
export const RU = 'ru';
export const EN = 'en';

export function setLang() {
  const link = window.location.href;
  if (link.includes(EN)) return EN;
  if (link.includes(KZ)) return KZ;
  return RU;
}

// глобальная переменная языка
export let lang = setLang();

const savedLang = localStorage.getItem('lang');
if (savedLang) {
  lang = savedLang;
}


export function setLangItem(item) {
  lang = item; 
  localStorage.setItem('lang', item);
  window.location.reload(); 
}
